/* CONFIGURATION */

var contentDomain = "https://steuerberatung-wettringen.de.news.atikon.de";
var splitPoint = "de/";


/* INHALTE */

var externalContent = [];

externalContent["steuernews_fuer_mandanten"] =
    "de/externe_inhalte/steuernews_für_mandanten/";

externalContent["steuernews_fuer_aerzte"] =
    "de/externe_inhalte/steuernews_für_ärzte/";


/* SECTION-ZUORDNUNG */

var newsSections = {
    steuernews_fuer_mandanten: "steuernews-mandanten",
    steuernews_fuer_aerzte: "steuernews-aerzte"
};


/* DOM READY */

var domready = {
    loaded: false,
    observers: [],
    callback: null,
    timer: null,

    add: function (fn) {
        if (domready.loaded) {
            fn();
            return;
        }

        domready.observers.push(fn);

        if (domready.callback) {
            return;
        }

        domready.callback = function () {
            if (domready.loaded) {
                return;
            }

            domready.loaded = true;

            if (domready.timer) {
                clearInterval(domready.timer);
                domready.timer = null;
            }

            for (var i = 0; i < domready.observers.length; i++) {
                domready.observers[i]();
            }

            domready.observers = [];
        };

        if (document.readyState === "loading") {
            document.addEventListener(
                "DOMContentLoaded",
                domready.callback,
                false
            );

            window.addEventListener(
                "load",
                domready.callback,
                false
            );
        } else {
            domready.callback();
        }
    }
};


/* HELPERS */

function getBaseUrl() {
    return window.location.href
        .split("#")[0]
        .split("?")[0];
}


function getRelativeNewsUrl(url) {
    var marker = "/" + splitPoint;
    var position = url.indexOf(marker);

    if (position === -1) {
        return null;
    }

    return url.substring(position + marker.length);
}


function getSectionId(divId) {
    return newsSections[divId] || null;
}


function updateNewsDetailClass() {
    var params = new URLSearchParams(window.location.search);

    var news = params.get("news");
    var url = params.get("url");

    var isDetail = !!(news && url);

    document.documentElement.classList.toggle(
        "is-news-detail",
        isDetail
    );

    document.documentElement.classList.toggle(
        "is-news-mandanten",
        isDetail && news === "steuernews_fuer_mandanten"
    );

    document.documentElement.classList.toggle(
        "is-news-aerzte",
        isDetail && news === "steuernews_fuer_aerzte"
    );
}


function scrollToNewsSection(divId, smooth) {
    var sectionId = getSectionId(divId);

    if (!sectionId) {
        return;
    }

    var section = document.getElementById(sectionId);

    if (!section) {
        return;
    }

    section.scrollIntoView({
        behavior: smooth ? "smooth" : "auto",
        block: "start"
    });
}


function buildNewsUrl(divId, url) {
    var relativeUrl = getRelativeNewsUrl(url);

    if (!relativeUrl) {
        return getBaseUrl();
    }

    var sectionId = getSectionId(divId);

    var result =
        getBaseUrl() +
        "?news=" +
        encodeURIComponent(divId) +
        "&url=" +
        encodeURIComponent(relativeUrl);

    if (sectionId) {
        result += "#" + encodeURIComponent(sectionId);
    }

    return result;
}


/* CONTENT LOADER */

function loadURL(divId, url, updateHistory, scrollAfterLoad) {
    if (typeof updateHistory === "undefined") {
        updateHistory = true;
    }

    if (typeof scrollAfterLoad === "undefined") {
        scrollAfterLoad = true;
    }

    var container = document.getElementById(divId);

    if (!container) {
        return;
    }

    container.innerHTML =
        '<span class="load">' +
            '<span>Inhalt wird geladen...</span>' +
        '</span>';

    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState !== 4) {
            return;
        }

        if (xmlhttp.status < 200 || xmlhttp.status >= 300) {
            container.innerHTML =
                '<p>Die Steuernews konnten nicht geladen werden.</p>';

            return;
        }


        /* Absolute URLs für Bilder / Assets herstellen */

        var regex =
            /((?:href|src|srcset|poster)=")(?:\/)?([^"]*)(")/g;

        var replacer =
            "$1" + contentDomain + "/$2$3";


        /* Atikon-Logo entfernen */

        var logoRegex =
            /<use [^>]*\bxlink:href\s*=\s*"[^"]*logo_sprite.*?<\/use>/g;

        var logoReplacer = "";


        /* SVG-Sprite entfernen */

        var svgRegex =
            /<use [^>]*\bxlink:href\s*=\s*"[^"]*sprite\.symbol.*?<\/use>/g;

        var svgReplacer = "";


        /* Response parsen */

        var html = document.createElement("div");

        html.innerHTML = xmlhttp.responseText
            .replace(regex, replacer)
            .replace(svgRegex, svgReplacer)
            .replace(logoRegex, logoReplacer);


        var external =
            html.getElementsByClassName("external_content")[0];

        if (!external) {
            container.innerHTML =
                '<p>Die Steuernews konnten nicht verarbeitet werden.</p>';

            return;
        }

        container.innerHTML = external.innerHTML;


        /* Browser-History */

        if (updateHistory) {
            var targetUrl = buildNewsUrl(divId, url);

            var titleElement =
                html.getElementsByTagName("title")[0];

            var title =
                titleElement
                    ? titleElement.innerHTML
                    : document.title;

            window.history.pushState(
                {
                    news: divId,
                    url: getRelativeNewsUrl(url)
                },
                title,
                targetUrl
            );

            updateNewsDetailClass();
        }


        /* Links innerhalb des geladenen Contents */

        var links = container.getElementsByTagName("a");

        for (var i = 0; i < links.length; i++) {
            (function (link) {

                /* Externe normale Links reparieren */

                if (
                    link.href.indexOf(
                        contentDomain + "/http"
                    ) !== -1
                ) {
                    link.href =
                        link.href.split(
                            contentDomain + "/"
                        )[1];
                }


                /* Drucken */

                if (
                    link.href.indexOf(
                        "javascript:window.print();"
                    ) !== -1
                ) {
                    link.href =
                        "javascript:window.print();";

                    return;
                }


                /* Downloads nicht intercepten */

                if (
                    /\.(pdf|zip|doc|docx|xls|xlsx|exe)$/i.test(
                        link.href
                    )
                ) {
                    return;
                }


                /* Normale Anker */

                if (
                    link.hash &&
                    link.pathname === window.location.pathname
                ) {
                    link.onclick = function (event) {
                        var anchor =
                            this.hash.substring(1);

                        var target =
                            document.getElementById(anchor);

                        if (!target) {
                            return;
                        }

                        event.preventDefault();

                        target.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    };

                    return;
                }


                /* News-Link / Detailseite */

                if (
                    link.href.indexOf(
                        "/" + splitPoint
                    ) !== -1
                ) {
                    link.onclick = function (event) {
                        event.preventDefault();

                        var hrefSplit =
                            this.href.split(
                                "/" + splitPoint
                            );

                        if (!hrefSplit[1]) {
                            return false;
                        }

                        var targetUrl =
                            contentDomain +
                            "/" +
                            splitPoint +
                            hrefSplit[1];

                        loadURL(
                            divId,
                            targetUrl,
                            true,
                            true
                        );

                        return false;
                    };
                }

            })(links[i]);
        }


        /* Selects mit onchange */

        var selects =
            container.getElementsByTagName("select");

        for (var s = 0; s < selects.length; s++) {
            (function (select) {

                if (!select.onchange) {
                    return;
                }

                select.onchange = function () {
                    var targetUrl =
                        contentDomain +
                        "/" +
                        this.value;

                    loadURL(
                        divId,
                        targetUrl,
                        true,
                        true
                    );
                };

            })(selects[s]);
        }


        /* Zur passenden Section scrollen */

        if (scrollAfterLoad) {
            window.setTimeout(function () {
                scrollToNewsSection(
                    divId,
                    updateHistory
                );
            }, 20);
        }
    };


    xmlhttp.open(
        "GET",
        url,
        true
    );

    xmlhttp.send(null);
}


/* CURRENT STATE LADEN */

function loadCurrentNewsState() {
    var params =
        new URLSearchParams(
            window.location.search
        );

    var requestedNews =
        params.get("news");

    var requestedUrl =
        params.get("url");


    for (var divId in externalContent) {
        if (
            !Object.prototype.hasOwnProperty.call(
                externalContent,
                divId
            )
        ) {
            continue;
        }

        if (!document.getElementById(divId)) {
            continue;
        }


        /* Gewählte Detailansicht */

        if (
            requestedNews === divId &&
            requestedUrl
        ) {
            var detailUrl =
                contentDomain +
                "/" +
                splitPoint +
                decodeURIComponent(
                    requestedUrl
                );

            loadURL(
                divId,
                detailUrl,
                false,
                true
            );
        }


        /* Alle anderen News-Bereiche als Übersicht */

        else {
            loadURL(
                divId,
                contentDomain +
                    "/" +
                    externalContent[divId],
                false,
                false
            );
        }
    }

    updateNewsDetailClass();


    /* Hash nach initialem Laden / Back / Forward berücksichtigen */

    if (window.location.hash) {
        var anchor =
            decodeURIComponent(
                window.location.hash.substring(1)
            );

        window.setTimeout(function () {
            var element =
                document.getElementById(anchor);

            if (element) {
                element.scrollIntoView({
                    behavior: "auto",
                    block: "start"
                });
            }
        }, 100);
    }
}


/* INITIALISIERUNG */

domready.add(function () {
    loadCurrentNewsState();
});


/* BROWSER BACK / FORWARD */

window.addEventListener(
    "popstate",
    function () {
        loadCurrentNewsState();
    },
    false
);